import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { reduxForm, Field } from 'redux-form';
import UploadImage from 'components/Fields/ReduxForm/UploadImage';
import SettingField from 'components/Fields/ReduxForm/SettingField';
import PhoneNumberField from 'components/Fields/ReduxForm/PhoneNumberField';
import ActionBarDetailWrapper from 'components/wrappers/pages/ActionBarDetailWrapper';
import LabelSection from 'components/sections/LabelSection';
import gravatarDefault from 'assets/images/account-profile-default.jpg';
import { onClickCancel } from 'actions/employees/staff';
import withFeatureFlags from 'hocs/withFeatureFlags';
import isMokaposUser from 'selectors/isMokaposUser';
import validator from 'validator';
import moment from 'moment';
import classNames from 'classnames';
import { useMokaOutletPropsFirst } from 'utils/formatter';
import AssignPasscode from './AssignPasscode';
import EmailField from './EmailField';
import styles from './StaffForm.css';
import EmployeeAssociationModal from '../EmployeeAssociationModal';

const validate = (values, props) => {
  const errors = {};
  // validate first_name
  if (!values.first_name) {
    errors.first_name = 'First Name is Required';
  } else if (values.first_name.length > 20) {
    errors.first_name = 'First Name must be less than 20 characters';
  }
  // validate last name
  if (!values.last_name) {
    errors.last_name = 'Last Name is Required';
  } else if (values.last_name.length > 30) {
    errors.last_name = 'Last Name must be less than 30 characters';
  }
  // validate email
  if (!values.email) {
    errors.email = 'Email is Required';
  } else if (!validator.isEmail(values.email)) {
    errors.email = 'Your email is not valid, please check the format';
  }
  if (values.assign_pin) {
    // validate pin length
    if (!values.pin || values.pin.length < 4) {
      errors.pin = 'Please enter at least 4 characters';
    }

    // check for existing pin not changed OR new employee
    if (
      props.formValues.id === undefined ||
      props.employee.pin !== values.pin
    ) {
      // validate unique pin
      if (props.employeePins.includes(parseInt(values.pin))) {
        errors.pin =
          'Please use a different combination. This PIN has already been assigned to another employee.';
      }
    }
  }
  return errors;
};
class StaffForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      initialFormValues: this.props.formValues,
      showEmployeeAssociationModal: false,
    };
  }

  showAssociationModal = () => {
    this.setState({
      showEmployeeAssociationModal: true,
    });
  };

  hideAssociationModal = () => {
    this.setState({
      showEmployeeAssociationModal: false,
    });
  };

  render() {
    const emailConfirmed =
      this.props.employee && this.props.employee.is_email_confirmed;
    const hashedOutlets = {};
    if (this.props.formValues && this.props.formValues.outlets) {
      this.props.formValues.outlets.forEach(oid => {
        hashedOutlets[`${oid}`] = true;
      });
    }
    const {
      selfView,
      searchFormValues,
      slot,
      canAssignPin,
      pinAccessImprovement,
      employee,
    } = this.props;
    const { showEmployeeAssociationModal } = this.state;
    const {
      assign_pin,
      role_id,
      is_enable_in_app_permission,
      pin,
    } = this.props.formValues;
    const selectedOutlets = this.props.outlets.filter(
      outlet => hashedOutlets[`${outlet.id}`]
    );
    const disabledField =
      searchFormValues && searchFormValues.status === 'inactive';

    const role_level =
      role_id !== undefined && pinAccessImprovement && !selfView
        ? this._checkIsAdministrator(role_id)
        : false;
    const pos_access =
      role_id !== undefined && pinAccessImprovement && !selfView
        ? this._checkHasPosAccess(role_id)
        : true;

    const immutable = !!employee?.hermes;
    const showAssociationNotice = !!employee?.hermes;

    return (
      <div className={styles.wrapper}>
        <div className={`${styles['field-wrapper']} staff-field-wrapper`}>
          {searchFormValues && searchFormValues.status === 'active' && (
            <div>
              {showAssociationNotice && (
                <div
                  className={classNames(
                    'alert alert-info',
                    styles['association-notice']
                  )}
                >
                  <div>
                    <i className="glyphicon glyphicon-exclamation-sign text-info" />
                    &nbsp; This employee is associated with a GoBiz account
                  </div>
                  <button
                    type="button"
                    className="btn btn-link"
                    onClick={this.showAssociationModal}
                  >
                    <b>Details</b>
                  </button>
                </div>
              )}
              {showEmployeeAssociationModal && (
                <EmployeeAssociationModal
                  moka={{ email: employee.email, phone: employee.phone }}
                  hermes={{
                    email: employee.hermes.email,
                    phone: employee.hermes.phone_number,
                  }}
                  onClose={this.hideAssociationModal}
                />
              )}

              <LabelSection title="Slot Status" />
              <div className={`row ${styles['slot-status']}`}>
                <div>
                  <span className="pull-left">
                    {!this.props.showLinkStopRenewal ? (
                      <small>Staff Slot will Active until</small>
                    ) : (
                      <small>Slot Expired at</small>
                    )}
                  </span>
                  <span className="pull-right">
                    <small>
                      {moment(slot.expireDate).format('DD/MM/YYYY')}
                    </small>
                  </span>
                </div>
                <br />
                <div>
                  {slot && slot.status === 'Free' ? (
                    <small>{`This slot will be deactivated once ${slot.outletName} expires`}</small>
                  ) : (
                    this.props.showLinkStopRenewal && (
                      <small
                        className={styles['stop-renewal']}
                        onClick={this.props.onClickStopRenewal}
                      >
                        Stop Renewal
                      </small>
                    )
                  )}
                </div>
              </div>
            </div>
          )}

          <LabelSection
            title={
              this.props.formValues.id ? 'EMPLOYEE DETAILS' : 'INVITE EMPLOYEE'
            }
          />
          <div className="row">
            <Field
              name="photo_url"
              component={UploadImage}
              className={styles['upload-image']}
              defaultImage={gravatarDefault}
              imageContainerClassName={styles['upload-image-content']}
              confirmOnDelete
            />
            <div className={`${styles['side-image-wrapper']}`}>
              <div className="row">
                <div className="col-md-6" style={{ paddingRight: '8px' }}>
                  <div className="form-group">
                    <Field
                      name="first_name"
                      component={SettingField}
                      placeholder="First Name"
                      dis={disabledField}
                      onChange={this._onChangeFieldName}
                    />
                  </div>
                </div>
                <div className="col-md-6" style={{ paddingLeft: '8px' }}>
                  <div className="form-group">
                    <Field
                      name="last_name"
                      component={SettingField}
                      placeholder="Last Name"
                      dis={disabledField}
                      onChange={this._onChangeFieldName}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-xs-12">
                  <div className="form-group">
                    {emailConfirmed && (
                      <input
                        className="form-control"
                        value={this.props.formValues.email}
                        disabled
                      />
                    )}
                    {!emailConfirmed && (
                      <Field
                        name="email"
                        component={EmailField}
                        readOnly={selfView}
                        disabled={disabledField || immutable}
                      />
                    )}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-xs-12">
                  <div className="form-group">
                    <Field
                      component={PhoneNumberField}
                      name="phone"
                      type="tel"
                      placeholder="812"
                      disabled={disabledField}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* prevent firefox to recognize this form as a login form, we must separate 'text' and 'password' input */}
          <input type="text" style={{ display: 'none' }} />
          <LabelSection title="Employee Role" />
          <div className="row">
            <div className="col-xs-12">
              <div className="form-group">
                {!selfView && (
                  <Field
                    component="select"
                    name="role_id"
                    className={`form-control ${styles.role}`}
                    disabled={disabledField}
                    onChange={pinAccessImprovement ? this._onChangeRole : ''}
                  >
                    <option hidden value="">
                      - Select Role -
                    </option>
                    {this.props.roles.map(role => {
                      return (
                        <option value={role.id} key={role.id}>
                          {role.name}
                        </option>
                      );
                    })}
                  </Field>
                )}
                {selfView && (
                  <select className={`form-control ${styles.role}`} disabled>
                    <option>{this.props.employee.role.name}</option>
                  </select>
                )}
              </div>
            </div>
            {canAssignPin && (
              <div className="col-xs-12">
                {pinAccessImprovement ? (
                  <AssignPasscode
                    assignPin={assign_pin || role_level}
                    selfView={selfView}
                    dispatch={this.props.dispatch}
                    currentPin={pin}
                    isEnableInAppPermission={is_enable_in_app_permission}
                    disabled={disabledField}
                    checked={role_level}
                    posAccess={pos_access}
                    generatedPin={pin || this._generateUniquePIN()}
                  />
                ) : (
                  <AssignPasscode
                    assignPin={assign_pin}
                    selfView={selfView}
                    dispatch={this.props.dispatch}
                    currentPin={pin}
                    disabled={disabledField}
                  />
                )}
              </div>
            )}
          </div>
          <div className="row mt-20px" />
          <LabelSection title="Assigned outlets" />
          <Field name="outlets" type="hidden" component="input" />
          <div className="row">
            {selectedOutlets.map(outlet => (
              <div
                key={outlet.id}
                className={`col-xs-12 ${styles['outlet-name']}`}
              >
                {useMokaOutletPropsFirst(outlet, o => o.name)}
              </div>
            ))}
            <div className="col-xs-12">
              <button
                className="btn btn-primary btn-block"
                onClick={() => {
                  if (!selfView) this.props.onClickAssignOutlet();
                }}
                disabled={selfView}
              >
                Assign Outlet
              </button>
            </div>
          </div>
          <div className="row mt-20px" />
          <LabelSection title="Description" />
          <div className="row">
            <div className="col-xs-12">
              <Field
                name="description"
                component="textarea"
                placeholder="Join date : 01 January 2017"
                className="form-control"
                rows="3"
                disabled={disabledField}
              />
            </div>
          </div>
        </div>
        <ActionBarDetailWrapper>
          {searchFormValues &&
            searchFormValues.status === 'active' &&
            slot.employee && (
              <span className="pull-left">
                <button
                  className="btn btn-danger"
                  onClick={this.props.onClickDeactivateEmployee}
                  disabled={this.props.deactivateDisabled}
                >
                  Deactivate Employee
                </button>
              </span>
            )}

          {searchFormValues &&
            searchFormValues.status !== 'active' &&
            this.props.formValues &&
            this.props.formValues.id && (
              <span className="pull-left">
                <button
                  className="btn btn-danger"
                  onClick={this.props.onClickDeleteEmployee}
                  disabled={this.props.selfView}
                >
                  <span className="fa fa-trash" />
                </button>
              </span>
            )}

          <span className="pull-right">
            <button
              type="button"
              className="btn btn-default mr-10px"
              onClick={this._onClickCancel}
            >
              Cancel
            </button>
            {searchFormValues && searchFormValues.status === 'active' ? (
              <button
                type="button"
                className="btn btn-primary"
                onClick={this.props.handleSubmit(this._onSubmit)}
                disabled={this.props.disableSubmit}
              >
                {this.props.formValues.id ? 'Save' : 'Invite'}
              </button>
            ) : (
              <button
                className="btn btn-primary"
                onClick={this.props.onClickReactivate}
              >
                Reactivate
              </button>
            )}
          </span>
        </ActionBarDetailWrapper>
      </div>
    );
  }

  _onSubmit = values => {
    values.first_name = values.first_name.trim();
    values.last_name = values.last_name.trim();
    this.props.onSubmit({ values });
  };

  _onClickCancel = () => {
    this.props.dispatch(onClickCancel());
  };

  _onChangeFieldName = e => {
    if (e.target.value.length > 0 && e.target.value[0] === ' ') {
      e.preventDefault();
    }
  };

  _onChangeRole = e => {
    if (this._checkHasPosAccess(e.target.value)) {
      // Check for Administrator role
      if (this._checkIsAdministrator(e.target.value)) {
        this.props.change('assign_pin', true);
        this.props.change('is_enable_in_app_permission', true);
      } else if (this.props.formValues.id === undefined) {
        // If not administrator but a new employee
        this.props.change('assign_pin', false);
        this.props.change('is_enable_in_app_permission', false);
      } else {
        // Set value according to initial value for non administrator employee on role change
        this.props.change(
          'assign_pin',
          this.state.initialFormValues.assign_pin
        );
        this.props.change(
          'is_enable_in_app_permission',
          this.state.initialFormValues.is_enable_in_app_permission
        );
      }

      //  Generate pin if only there's no pin
      if (typeof this.props.formValues.pin === 'undefined') {
        this.props.change('pin', this._generateUniquePIN());
      }
    } else {
      // Force to false if no POS Access for selected role
      this.props.change('assign_pin', false);
      this.props.change('is_enable_in_app_permission', false);
    }
  };

  _checkHasPosAccess(role_id) {
    const rolePermissions = this.props.roles.find(
      role => role.id === parseInt(role_id)
    ).permissions;
    return rolePermissions.find(
      rolePermission => rolePermission.access === 'App'
    );
  }

  _checkIsAdministrator(role_id) {
    return (
      this.props.roles.find(role => role.id === parseInt(role_id)).level === 2
    );
  }

  _generateUniquePIN = () => {
    let pin = '';
    do {
      pin = this._generateRandomPIN();
    } while (this.props.employeePins.includes(pin));
    return pin;
  };

  _generateRandomPIN = () => {
    return Math.floor(Math.random() * 8999 + 1000);
  };
}

const mapForm = {
  form: 'staff',
  validate,
  touchOnChange: true,
};

StaffForm.propTypes = {
  outlets: PropTypes.array,
  onClickAssignOutlet: PropTypes.func,
  onSubmit: PropTypes.func,
  employee: PropTypes.object,
  roles: PropTypes.array,
  formValues: PropTypes.object,
  onClickDeleteEmployee: PropTypes.func,
  selfView: PropTypes.bool,
  disableSubmit: PropTypes.bool,
  searchFormValues: PropTypes.object,
  onClickDeactivateEmployee: PropTypes.func,
  slot: PropTypes.object,
  onClickReactivate: PropTypes.func,
  deactivateDisabled: PropTypes.bool,
  onClickStopRenewal: PropTypes.func,
  showLinkStopRenewal: PropTypes.bool,
  canAssignPin: PropTypes.bool,
  pinAccessImprovement: PropTypes.bool,
  employeePins: PropTypes.array,
};

StaffForm.defaultProps = {
  selfView: true,
  canAssignPin: false,
};

const mapStateToProps = state => {
  return {
    canAssignPin: isMokaposUser(state),
  };
};

const connected = connect(mapStateToProps)(reduxForm(mapForm)(StaffForm));

const mapFlagsToProps = flags => ({
  pinAccessImprovement: flags.pinAccessImprovement,
});

export default withFeatureFlags(mapFlagsToProps)(connected);
